<template>
	<div>
		<contest-beneficiaries-table :announced="contestInfo.announced"></contest-beneficiaries-table>
		<d-a-c-codes :announced="contestInfo.announced"></d-a-c-codes>
	</div>
</template>

<script>
	import ContestBeneficiariesTable from "./components/ContestBeneficiariesTable";
	import DACCodes from "./components/ContestDACCodes";
	import {PublicContest} from "@/api/generated/PublicContest";

	export default {
		name: "ContestContantFieldsView",
		components: {ContestBeneficiariesTable, DACCodes},

		created () {
		PublicContest.getStatus(this, this.$route.params.id, response => {
				this.contestInfo = response;
			});
		},

		data () {
			return {
				contestInfo: {
					announced: undefined,
				},
			};
		}
	};
</script>

<style scoped>

</style>
